import { formatDate } from '../../common/utils/date-utils'
import { CreateStudentDto } from '../../pages/users/api/dto/create/CreateStudentDto'
import { CreateUserDto } from '../../pages/users/api/dto/create/CreateUserDto'
import { CreateUserUI } from '../../pages/users/model/CreateUserUI'
import Language from './Language'

class CreateUser {
  private constructor(
    email: string,
    firstName: string,
    lastName: string,
    fatherName: string | undefined,
    address: string | undefined,
    phoneNumber: string | undefined,
    mobileNumber: string | undefined,
    birthday: Date,
    idNumber: string,
    ssrNumber: string,
    vatNumber: string,
    visuallyImpaired: boolean,
    language: Language,
    sound: boolean,
  ) {
    this.email = email
    this.firstName = firstName
    this.lastName = lastName
    this.fatherName = fatherName ? fatherName : ''
    this.address = address ? address : ''
    this.phoneNumber = phoneNumber ? phoneNumber : ''
    this.mobileNumber = mobileNumber ? mobileNumber : ''
    this.birthday = birthday
    this.idNumber = idNumber
    this.ssrNumber = ssrNumber
    this.vatNumber = vatNumber
    this.visuallyImpaired = visuallyImpaired
    this.language = language
    this.sound = sound
  }

  private readonly email: string
  private readonly firstName: string
  private readonly lastName: string
  private readonly fatherName: string
  private readonly address: string
  private readonly phoneNumber: string
  private readonly mobileNumber: string
  private readonly birthday: Date
  private readonly idNumber: string
  private readonly ssrNumber: string
  private readonly vatNumber: string
  private readonly visuallyImpaired: boolean
  private readonly language: Language
  private readonly sound: boolean

  isValid(): boolean {
    return true
  }

  toStudentDto(): CreateStudentDto {
    return {
      user: {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        fatherName: this.fatherName,
        address: this.address,
        phoneNumber: this.phoneNumber,
        mobileNumber: this.mobileNumber,
        birthday: formatDate(this.birthday),
        idNumber: this.idNumber,
        ssrNumber: this.ssrNumber,
        vatNumber: this.vatNumber,
        visuallyImpaired: this.visuallyImpaired,
        language: this.language,
        sound: this.sound,
      } satisfies CreateUserDto,
      licenses: [],
    } satisfies CreateStudentDto
  }

  toCreateUserUI(): CreateUserUI {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      fatherName: this.fatherName,
      address: this.address,
      phoneNumber: this.phoneNumber,
      mobileNumber: this.mobileNumber,
      birthday: this.birthday,
      idNumber: this.idNumber,
      ssrNumber: this.ssrNumber,
      vatNumber: this.vatNumber,
      visuallyImpaired: this.visuallyImpaired,
      language: this.language,
      sound: this.sound,
    } satisfies CreateUserUI
  }

  static fromCreateUserUI(createUserUI: CreateUserUI): CreateUser {
    return new CreateUser(
      createUserUI.email,
      createUserUI.firstName,
      createUserUI.lastName,
      createUserUI.fatherName,
      createUserUI.address,
      createUserUI.phoneNumber,
      createUserUI.mobileNumber,
      createUserUI.birthday,
      createUserUI.idNumber,
      createUserUI.ssrNumber,
      createUserUI.vatNumber,
      createUserUI.visuallyImpaired,
      createUserUI.language,
      createUserUI.sound,
    )
  }
}

export default CreateUser
